import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import { useQuery } from 'src/modules/apollo';
import { GetIdDocument, type GetIdQuery } from 'src/types/graphql';

export const useUser = () => useQuery<GetIdQuery>(GetIdDocument);

export const useAuthenticationStatus = () => {
  const { loading, data } = useUser();

  if (loading) {
    return AUTHENTICATION_TYPES.AUTH_PENDING;
  }
  if (data?.viewer?._id) {
    return AUTHENTICATION_TYPES.AUTHENTICATED;
  }
  return AUTHENTICATION_TYPES.UNAUTHENTICATED;
};
